<div #block>
    <ng-content select="[content]"></ng-content>
</div>
